import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { selectOfferStepDefinition } from "../TrainOfferPage/SelectOfferFlow/SelectOfferStartupFlow";
import { SelectOfferTransition } from "../TrainOfferPage/SelectOfferFlow/Transition/SelectOfferTransition";
import { ticketOptionMainStepDefinition } from "../TrainOfferPage/TicketOptionFlow/TicketOptionStartupFlow";
import { TicketOptionTransition } from "../TrainOfferPage/TicketOptionFlow/Transition/TicketOptionTransition";
import { ChangeDateInitStepDeclaration } from "./Steps/ChangeDateInitStep";
import { ChangeDateTransition } from "./Transition/ChangeDateTransition";

export const changeDateMainStartupFlow = new FlowDefinition("ChangeDateFlow");

changeDateMainStartupFlow.addStep(ChangeDateInitStepDeclaration);
changeDateMainStartupFlow.addStep(selectOfferStepDefinition);
changeDateMainStartupFlow.addStep(ticketOptionMainStepDefinition);
changeDateMainStartupFlow.addStep(checkoutStepDefinition);

changeDateMainStartupFlow.addLink("ChangeDateInit_Step", "SelectOfferFlow");
changeDateMainStartupFlow.addLink("ChangeDateInit_Step", "TicketOptionFlow");
changeDateMainStartupFlow.addLink("TicketOptionFlow", "CheckoutFlow");
changeDateMainStartupFlow.addLink("SelectOfferFlow", "CheckoutFlow");

//This is because, we need to come back from the offer page to CDT init step
changeDateMainStartupFlow.addLink("SelectOfferFlow", "ChangeDateInit_Step");

//This is because, When we have Round Trip - Need to again start SelectOfferFlow and TicketOptionFlow from TicketOptionFlow
changeDateMainStartupFlow.addLink("TicketOptionFlow", "SelectOfferFlow");

changeDateMainStartupFlow.addLink("TicketOptionFlow", "TicketOptionFlow");

changeDateMainStartupFlow.addTransition(ChangeDateTransition, "ChangeDateInit_Step");
changeDateMainStartupFlow.addTransition(TicketOptionTransition, "TicketOptionFlow");
changeDateMainStartupFlow.addTransition(SelectOfferTransition, "SelectOfferFlow");

changeDateMainStartupFlow.setStartStep("ChangeDateInit_Step");

export const changeDateStepFlowDefinition = new StepDefinition({
    stepName: "ChangeDateFlow",
    stepFlow: changeDateMainStartupFlow,
    contextIsolation: false
})
